var _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsotipo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    enableBackground: "new 0 0 180 180",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4500.8174,
    y1: -1410.4927,
    x2: 4466.6855,
    y2: -1408.1056,
    gradientTransform: "matrix(-0.9994 0.0349 -0.0349 -0.9994 4534.8081 -1492.1982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2273AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0852,
    style: {
      stopColor: "#267BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1977,
    style: {
      stopColor: "#2781C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3259,
    style: {
      stopColor: "#2683C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4604,
    style: {
      stopColor: "#2985C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5801,
    style: {
      stopColor: "#2F8AC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6943,
    style: {
      stopColor: "#3893BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8051,
    style: {
      stopColor: "#44A0B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9124,
    style: {
      stopColor: "#53B0AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#60C29F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M83.026,89.544c0,0,0.352-11.387,13.685-9.6c0,0,9.877,1.546,18.147-3.899 c0,0,8.438-5.304,5.649-13.002c0,0-2.878-7.885-13.983-5.213C106.524,57.83,83.538,64.092,83.026,89.544z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.2476,
    y1: 105.4111,
    x2: 97.7092,
    y2: 105.4111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2683C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    style: {
      stopColor: "#2785C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#288BC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4955,
    style: {
      stopColor: "#2994C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#2CA2BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    style: {
      stopColor: "#31B2B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8274,
    style: {
      stopColor: "#32BDB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9203,
    style: {
      stopColor: "#49B7A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#57B393"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M102.37,89.829c0,0-0.617,11.119-13.325,9.307c0,0-10.156-1-18.959,3.072 c0,0-9.51,4.182-6.101,12.797c0,0,2.529,7.537,13.795,5.699C77.78,120.704,101.545,116.011,102.37,89.829z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#30455D",
    cx: 92.698,
    cy: 89.544,
    r: 9.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.252,
    y1: 92.5933,
    x2: 89.252,
    y2: 92.5933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2683C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    style: {
      stopColor: "#2884C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5863,
    style: {
      stopColor: "#2C88C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    style: {
      stopColor: "#328DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7866,
    style: {
      stopColor: "#3A96BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    style: {
      stopColor: "#45A0B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#51AEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#5EBDA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#60C29F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M89.252,92.593"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#263949",
    d: "M78.377,92.75"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipo);
export default __webpack_public_path__ + "static/media/isotipo.bf1b6bbecd9e892acbe0fd79aa307bda.svg";
export { ForwardRef as ReactComponent };